export enum AppModeModel {
    MultiUser = 0,
    Personal = 1,
}
